import React from 'react';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import Icon from 'components/Icon';
import Spacer from 'components/Spacer';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  flex-grow: 1;
  min-width: 250px;
  min-height: 50vh;
`;

const SettingsIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  z-index: 1;
  
  /* Zoom on scroll */
  transform: scale(1);
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.1);
  }
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const EmptyText = styled.span`
  font-family: Barlow Condensed;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
`;

const AddText = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  max-width: 60%;
  color: #d1d1d1;
`;

export const EmptyCart = ({ event }) => {
  const history = useHistory();

  const pathname = useLocation().pathname;
  const userType =
    ['admin-employee', 'admin-track'].find((type) => pathname.includes(type)) ||
    'admin';

  const openSettings = () => {
    history.push(`/${userType}/events/posSettings/${event.id}`, {
      event: event,
    });
  };

  return (
    <Wrapper>
      <SettingsIcon onClick={openSettings}>
        <Icon icon="settings-icon" size={24} color="#fff" />
      </SettingsIcon>
      <Container>
        <Icon icon="shopping_cart" size={128} color="#fff" />
        <Spacer size={15} />
        <EmptyText>Empty Cart</EmptyText>
        <AddText>Add items by selecting options in the left columns.</AddText>
      </Container>
    </Wrapper>
  );
};
